import {Component, OnDestroy, OnInit, ViewChild} from "@angular/core";
import {finalize, Subscription, tap, throwError} from "rxjs";
import {
  bulkUploadTemplateValues,
  defaultSelectedNonIOHUserRows,
  NonIOHUserRows,
  User,
  UserSettings,
  userExperimentModesValues,
  UserFilterDropdown,
  UserFilterDropdownPermissions,
  userSettingsLabels,
  userSettingsValues,
  UserStatus,
  userStatusValues, notAllowedForAgencyAdmin,
  UniversalCaptureModeEnum,
  universalCaptureModeOptions,
  careCompassUserOptions,
} from "../../models/user";
import {
  Agency,
  NonIOHRoleFilterOptions,
  Providers,
  ProvidersFilter,
  RoleEnum,
  Roles,
  status,
  statusValues
} from "../../models/agency";
import {ConfirmationService, SelectItem} from "primeng/api";
import {FormArray, FormBuilder, FormGroup, Validators} from "@angular/forms";
import {
  ACTIVATION_EMAIL_SUCCESS_MESSAGE,
  dateAndTimeFormat,
  dateFormat,
  DEFAULT_SEARCH_MIN_CHARACTER,
  EMAIL_ALREADY_REGISTERED_USER,
  FILE_DOWNLOAD_SUCCESS,
  MfaAllowedRoles,
  NEW_PASSWORD_REQUEST_SEND,
  NO_OF_RECORDS_PER_PAGE,
  REGISTRATION_WAITING_STATUS,
  RoleID,
  OnlySuperAdminAllowedRoles,
  rowsPerPageOptions,
  superAdminRoles,
  TEMP_PASSWORD_EXPIRED,
  USER_ACCOUNT_ALREADY_EXIST,
  USER_ACTIVITY_HOURS_IN_PAST,
} from "../../common/Constants";
import {countries} from "../../models/country-data";
import {Paginator} from "primeng/paginator";
import {FileUpload} from "primeng/fileupload";
import {UserService} from "../../services/user.service";
import {MessageHandlerService} from "../../services/message-handler.service";
import {UserDataManager} from "../../user/UserDataManager";
import {AgencyService} from "../../services/agency/agency.service";
import {ProgressBarService} from "../../services/progress-bar.service";
import {uploadBulkUsers} from "../bulk-user-upload";
import {MatIconRegistry} from "@angular/material/icon";
import {DomSanitizer} from "@angular/platform-browser";
import {HttpErrorResponse, HttpParams} from "@angular/common/http";
import {UtilService} from "../../services/util/util.service";
import {LocalStorageService} from "src/app/services/local-storage.service";
import {DatePipe} from "@angular/common";
import {isMfaChange, isMultiAgenciesUserEnabled} from "../../services/util/helper.function";
import {Dropdown} from "primeng/dropdown";
import {Company, CompanyUserRegistrationType, CompanyUserRegistrationTypeEnum, nonMdmCustomerOptions, NonMDMCustomerEnum} from "src/app/models/company";
import {CompanyService} from "src/app/services/company/company.service";
import {catchError} from "rxjs/operators";
import { EmailValidator } from "../../helper/confirmed.validator";
import { AppLinkService } from "../../services/app-link/app-link.service";
import { AppLink } from "../../models/app-link";

@Component({
  selector: "app-non-ioh-users",
  templateUrl: "./non-ioh-users.component.html",
  styleUrls: ["./non-ioh-users.component.scss"],
})
export class NonIohUsersComponent implements OnInit, OnDestroy {
  subscribers: Subscription[] = [];
  users: User[] = [];
  currentUser: User;
  currentAgencyRole: { agency: string; role: string };
  dateFormat = dateFormat;
  totalUsers: number = 0;
  display = false;
  globalRoles: string;
  roles = Roles;
  statusValues = statusValues;
  agencies: SelectItem[] = [];
  providers: SelectItem[] = Providers;
  registrationTypes: SelectItem[] = CompanyUserRegistrationType;
  providersFilter: SelectItem[] = ProvidersFilter;
  canActivateProviders = false;
  agenciesFilter: SelectItem[] = [];
  originalAgenciesFilter: SelectItem[] = [];
  selectedAgencies: Agency[] = [];
  numberOfAgencies: number = 0;
  searchUser: string = "";
  currentImage: any;
  statusEnum = status;
  newUserForm: FormGroup;
  countries = countries;
  userDropDownOptions: SelectItem[];
  selectedItem: any;
  selectedIndex: number;
  showEditForm: boolean = false;
  filteredAgencies: any[];
  agencyDetails: Agency[];
  pageNo: number = 0;
  noOfUsersPerRow: number = NO_OF_RECORDS_PER_PAGE;
  rowsPerPageOptions: number[] = rowsPerPageOptions;
  isChangingPage: boolean = false;
  SUPER_ADMIN = RoleID.Admin;
  IOH_ADMIN = RoleID.iohAdmin;
  AGENCY_ADMINISTRATOR = RoleID.AgencyAdmin;
  COMPANY_ADMIN = RoleID.companyAdmin;
  CLINICIAN = RoleID.Clinician;
  selectedAgency: string = "";
  selectedFilterAgency: string[] = [];
  userStatusFilterOptions: SelectItem[] = userStatusValues;
  bulkUploadTemplateOptions = bulkUploadTemplateValues;
  selectedUserStatus;
  userStatusFilter: string = "";
  bulkUploadTemplate;
  roleEnum = RoleEnum;
  emailType = "";
  dateAndTimeFormat = dateAndTimeFormat;
  selectedRows: any[] = defaultSelectedNonIOHUserRows;
  visibleRows: any[] = NonIOHUserRows;
  userFilter: any[] = UserFilterDropdown;
  userFilterSelectedRows: any[] = [];
  appLinks: AppLink[] = [];
  appLinkOptions: SelectItem[] = [];
  selectedAppLinkId: string | number | null = null;
  isFetchingAppLinks = false;
  isSendingAppLinkEmail = false;
  nonMdmCustomerOptions: SelectItem[] = nonMdmCustomerOptions;
  isSuperAdminOnlyRole = false;
  private nonMdmValueChangeSub?: Subscription;
  newUserAgencies: SelectItem[] = [];
  rolesFilterOptions: SelectItem[] = NonIOHRoleFilterOptions;
  selectedRoles: string[] = [];
  selectedProvider: string[] = [];
  defaultSearchMinCharacter = DEFAULT_SEARCH_MIN_CHARACTER;
  disableMultiAgencyFilter: boolean = true;
  showUserCreationSuccessPopup: boolean = false;
  loading: boolean = false;
  componentLocalStorageKey = "nonIohUser";
  companies: SelectItem[] = [];
  companiesPayload: Company[] = [];
  filteredCompanies: any[];
  userRegistrationStatus: boolean = false;
  userSettingsLabels;
  notAllowedAgencyAdminSettings = notAllowedForAgencyAdmin;
  allUserSettingLabels = userSettingsLabels;
  isLoginWithPCIDEnabled = CompanyUserRegistrationTypeEnum.Enabled;
  NonMDMCustomerEnum = NonMDMCustomerEnum;
  mlRulesOptions: SelectItem[] = [
    { label: 'Enable', value: true },
    { label: 'Disable', value: false },
    { label: 'Not Set', value: null }
  ];
  universalCaptureModeOptions: SelectItem[] = universalCaptureModeOptions;
  careCompassUserOptions: SelectItem[] = careCompassUserOptions;
  UniversalCaptureModeEnum = UniversalCaptureModeEnum;

  @ViewChild("paginator") paginator: Paginator;
  @ViewChild("fileUpload", { static: false }) fileUpload: FileUpload;
  @ViewChild("bulkUploadUsers", { static: false }) bulkUploadUsers: FileUpload;
  @ViewChild("downloadTemplateDropdown") dropdown: Dropdown;
  mfaEnabled: boolean = false;
  mfaTokenEnabled: boolean = false;
  userExperimentModeValues = userExperimentModesValues;

  private readonly fieldNameMap: { [key: string]: string } = {
    'firstName': 'First Name',
    'lastName': 'Last Name',
    'email': 'Email',
    'phone.number': 'Phone Number',
    'companyId': 'Company',
    'workerId': 'Worker ID',
    'status': 'Status',
    'agency_roles': 'Agency Roles',
    'userSettings.logging': 'Logging',
    'userSettings.loggingView': 'Logging View',
    'userSettings.isIOHHelp': 'ioAssist',
    'userSettings.mfa': 'MFA SMS',
    'userSettings.mfa_token': 'MFA Token',
    'userSettings.isMultiAgenciesAllowed': 'Multi-Agency Access',
    'userSettings.disableUpdatePopup': 'App Update Popup',
    'userSettings.universalCaptureEnabled': 'Universal Capture Enabled',
    'userSettings.universalCaptureMode': 'Universal Capture Mode',
    'userSettings.showMedicationsPanel': 'Show Medications Panel',
    'userSettings.showCareCompass': 'Care Compass',
    'loginWithPCIDenabled': 'Login with PCID',
    'provider': 'Provider',
    'agency': 'Name',
    'roles': 'Role'
  };

  isSubmitting: boolean = false;

  constructor(
    private readonly userService: UserService,
    private readonly messageHandlerService: MessageHandlerService,
    public readonly userDataManager: UserDataManager,
    private readonly agencyService: AgencyService,
    private readonly companyService: CompanyService,
    private readonly progressBarService: ProgressBarService,
    private readonly formBuilder: FormBuilder,
    private readonly confirmationService: ConfirmationService,
    private readonly matIconRegistry: MatIconRegistry,
    private readonly utilService: UtilService,
    private readonly localStorageService: LocalStorageService,
    private readonly domSanitizer: DomSanitizer,
    private readonly datePipe: DatePipe,
    private readonly appLinkService: AppLinkService,
  ) {
    this.userDropDownOptions = [
      { label: "Edit", value: "Edit" },
      { label: "Delete", value: "Delete" },
      { label: "Inactive", value: "Inactive" },
    ];
    this.matIconRegistry.addSvgIcon("status", this.domSanitizer.bypassSecurityTrustResourceUrl("assets/images/active-inactive.svg"));
    this.matIconRegistry.addSvgIcon("delete", this.domSanitizer.bypassSecurityTrustResourceUrl("assets/images/delete-item.svg"));
  }

  get role(): FormArray {
    return this.newUserForm.get("agency_roles") as FormArray;
  }

  get packages(): FormArray {
    return this.newUserForm.get("packages") as FormArray;
  }

  // App Packages lists the apps on the clinician's tablet, which every tablet uploads whether or
  // not Universal Capture is on. Show it only to Super Admin / IOH Admin (the only roles that can
  // change a package's mode) and only while Universal Capture is ticked. updateUser() sends
  // packages only when this is true (IOHB-2069).
  get showAppPackages(): boolean {
    return (
      this.showEditForm &&
      this.packages.length > 0 &&
      !!(this.currentUser?.is_super_admin || this.currentUser?.is_IOH_admin) &&
      !!this.newUserForm.get("userSettings.universalCaptureEnabled")?.value
    );
  }

  createPackageGroup(pkg: any): FormGroup {
    return this.formBuilder.group({
      appName: [pkg?.appName || ""],
      packageName: [pkg?.packageName || ""],
      versionName: [pkg?.versionName || ""],
      buildNumber: [pkg?.buildNumber ?? null],
      isSystem: [pkg?.isSystem ?? false],
      mode: [pkg?.mode || UniversalCaptureModeEnum.Ignore],
    });
  }

  // A single-option dropdown just for display — packageName identifies the row and isn't
  // meant to be reassigned to a different package here.
  packageNameOptions(index: number): SelectItem[] {
    const pkg = this.packages.at(index)?.value;
    return pkg?.packageName ? [{ label: pkg.packageName, value: pkg.packageName }] : [];
  }

  async customSort(event) {
    this.users = [];
    this.totalUsers = 0;
    const nonIOHUsersSorting = {
      order: event?.sortOrder,
      orderBy: event?.sortField,
    };

    this.localStorageService.set("nonIOHUsersSorting", JSON.stringify(nonIOHUsersSorting));
    this.getUsers(event?.sortOrder, event?.sortField);
  }

  ngOnInit(): void {
    this.getCurrentUser();
    this.filterSettingsByRole();
    this.getDataFromLocalStorage();
    this.getCurrentAgencyRole();
    this.createUsersForm();
    this.getSelectedRows();
    if (this.currentUser?.is_IOH_admin || this.currentUser?.is_super_admin) {
      this.getCompanyListing();
    } else if (this.currentUser?.is_company_admin) {
      this.getCompanyListing(this.currentUser.companyId);
    }
  }

  getDataFromLocalStorage() {
    const nonIohUser = JSON.parse(this.localStorageService.get(this.componentLocalStorageKey));
    this.selectedFilterAgency = nonIohUser?.selectedFilterAgency ? nonIohUser?.selectedFilterAgency : [];
    this.userFilterSelectedRows = nonIohUser?.userFilterSelectedRows ? nonIohUser?.userFilterSelectedRows : [];
    this.selectedRoles = nonIohUser?.selectedRoles ? nonIohUser?.selectedRoles : [];
    this.selectedProvider = nonIohUser?.selectedProvider ? nonIohUser?.selectedProvider : [];
    this.selectedUserStatus = nonIohUser?.selectedUserStatus ? nonIohUser?.selectedUserStatus : "";
    this.userStatusFilter = this.selectedUserStatus;

    this.prePopulatePerPage();
  }

  prePopulatePerPage() {
    const global = JSON.parse(this.localStorageService.get("globalPageLimit"));
    if (global) {
      this.noOfUsersPerRow = global.perPage;
    }
  }

  resetMultiSelectDataInLocalStorage() {
    this.utilService.setDataInLocalStorage(this.componentLocalStorageKey, "pageNo", this.pageNo);
    this.utilService.setDataInLocalStorage(this.componentLocalStorageKey, "selectedFilterAgency", this.selectedFilterAgency);
    this.utilService.setDataInLocalStorage(this.componentLocalStorageKey, "userFilterSelectedRows", this.userFilterSelectedRows);
    this.utilService.setDataInLocalStorage(this.componentLocalStorageKey, "selectedRoles", this.selectedRoles);
    this.utilService.setDataInLocalStorage(this.componentLocalStorageKey, "selectedProvider", this.selectedProvider);
    this.utilService.setDataInLocalStorage(this.componentLocalStorageKey, "selectedUserStatus", this.selectedUserStatus);
  }

  canEnablePermissionsEmail(user: User) {
    let canEnable = false;
    let allowedRoles: string[] = [RoleID.Admin, RoleID.iohAdmin, RoleID.companyAdmin, RoleID.AgencyAdmin];
    let isAllowedRole: boolean = allowedRoles.includes(this.currentAgencyRole?.role);
    let permissionsExists = false;
    if (user?.permissions && user?.permissions.length > 0) {
      permissionsExists = this.checkValuesExist(user?.permissions);
    }

    if (!permissionsExists && isAllowedRole) {
      if (user.agency_roles && user.agency_roles.length)
        user.agency_roles.forEach((agency_role) => {
          if (agency_role.roles.includes(RoleID.Clinician)) canEnable = true;
        });
    }

    return canEnable;
  }

  checkValuesExist(permissions) {
    for (let i = 0; i < UserFilterDropdownPermissions.length; i++) {
      if (!(permissions.includes(UserFilterDropdownPermissions[i]) || permissions.includes(UserFilterDropdownPermissions[i].toLowerCase()))) {
        return false;
      }
    }
    return true;
  }

  onAgencySelect(currentIndex?: number) {
    // Commented out to fix the issue of the dropdown options being reset when multiple agency blocks are added.
    //
    // Previously this mutated the shared `agencies` options list (disabling/remapping items)
    // based on other rows' selections. That caused `p-dropdown` selections to appear "reset"
    // when multiple agency blocks were added, and prevented selecting the same agency again.
    //
    // Each agency block should be independent, so we keep the dropdown options list stable.

    // const agencyRoles = this.newUserForm.value?.agency_roles ?? [];
    // // Exclude the current row so we don't disable the option being selected in this dropdown
    // const selectedAgencies =
    //   typeof currentIndex === "number"
    //     ? agencyRoles.filter((_: unknown, i: number) => i !== currentIndex)
    //     : agencyRoles;
    // const selectedAgenciesSet = new Set(
    //   selectedAgencies.map((item: { agency: string | object }) =>
    //     typeof item.agency === "object" && item.agency !== null && "value" in item.agency
    //       ? (item.agency as { value: string }).value
    //       : item.agency
    //   )
    // );
    // this.agencies = this.agencies.map((item) => {
    //   if (selectedAgenciesSet.has(item.value)) {
    //     return { ...item, disabled: true };
    //   } else {
    //     return { ...item, disabled: false };
    //   }
    // });
    return;
  }

  getSelectedRows() {
    if (!this.localStorageService.get("userSettings" + this.currentUser?.aws_cognito_id)) {
      this.selectedRows = defaultSelectedNonIOHUserRows;
      this.localStorageService.set("userSettings" + this.currentUser?.aws_cognito_id, JSON.stringify({ selectedNonIOHUserRows: this.selectedRows }));
    } else {
      this.selectedRows = JSON.parse(this.localStorageService.get("userSettings" + this.currentUser?.aws_cognito_id))?.selectedNonIOHUserRows
        ? JSON.parse(this.localStorageService.get("userSettings" + this.currentUser?.aws_cognito_id))?.selectedNonIOHUserRows
        : defaultSelectedNonIOHUserRows;
    }
  }

  ngOnDestroy(): void {
    if (this.subscribers.length > 0) {
      this.subscribers.forEach((sub) => {
        sub.unsubscribe();
      });
    }
    if (this.nonMdmValueChangeSub) {
      this.nonMdmValueChangeSub.unsubscribe();
      this.nonMdmValueChangeSub = undefined;
    }
  }

  getCurrentAgencyRole() {
    this.subscribers.push(
      this.userDataManager.activeAgencyRole$.subscribe((currentRole) => {
        this.currentAgencyRole = currentRole;
        this.selectedAgency = currentRole?.agency;

        if (this.currentUser?.userSettings?.isMultiAgenciesAllowed) {
          this.setAgencyAutoCompleteOptions();
        } else {
          this.getAgencyListing();
        }
        this.addCompanyAdminFilter();
        this.getUsers();
      }),
    );
  }

  addCompanyAdminFilter() {
    const isCompanyAdmin = this.rolesFilterOptions.findIndex((rolesFilterOption) => rolesFilterOption.value == this.COMPANY_ADMIN);

    if (this.currentAgencyRole.role == this.IOH_ADMIN || this.currentAgencyRole.role == this.SUPER_ADMIN) {
      if (isCompanyAdmin == -1) {
        const companyOption = {
          value: this.COMPANY_ADMIN,
          label: "Company Admin",
        };

        this.rolesFilterOptions.splice(1, 0, companyOption);
      }
    } else if (isCompanyAdmin != -1) {
      this.rolesFilterOptions.splice(1, 1);
    }
  }

  filterSettingsByRole() {
    if(this.currentUser.defaultRole == this.AGENCY_ADMINISTRATOR || this.currentUser.is_company_admin == true) {
      // Agency admin sees only those which are not allowed list
      this.userSettingsLabels = this.allUserSettingLabels.filter(
        setting => !this.notAllowedAgencyAdminSettings.includes(setting.value)
      );
    } else {
      // Default fallback
      this.userSettingsLabels = this.allUserSettingLabels;
    }
  }


  setAgencyAutoCompleteOptions() {
    if (this.currentUser?.agency_roles) {
      this.agencies = this.currentUser.agency_roles
        .filter((agency_role) => agency_role.roles.includes(this.AGENCY_ADMINISTRATOR))
        .map((agency_role) => ({
          label: agency_role.agency?.agencyName,
          value: agency_role.agency?.agencyID,
        }));
    } else {
      this.agencies = [];
    }
  }

  filterAgencies(event) {
    let filtered: any[] = [];
    let query = event.query;
    this.newUserAgencies = this.agencies.filter((agencie) => agencie.label !== "All" && agencie.value !== "");

    for (let i = 0; i < this.newUserAgencies.length; i++) {
      let checkIfAlreadySelected = false;
      let agency = this.newUserAgencies[i];

      if (agency?.label?.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        const formData = this.newUserForm.value;

        formData.agency_roles.forEach((agencyRole) => {
          if (agency?.value && agencyRole?.agency?.value == agency?.value) {
            checkIfAlreadySelected = true;
          }
        });

        if (!checkIfAlreadySelected) {
          filtered.push(agency);
        }
      }
    }

    this.filteredAgencies = filtered;
  }

  async getCurrentUser() {
    this.subscribers.push(
      await this.userDataManager.user$.subscribe((user) => {
        if (user) {
          this.currentUser = user;
        }
      }),
    );
  }

  removeAgency(index) {
    const agencyArray = this.newUserForm.get("agency_roles") as FormArray;
    agencyArray.removeAt(index);

    this.onSelectedRoleChange();
  }

  createUsersForm() {
    this.newUserForm = this.formBuilder.group({
      is_super_admin: false,
      is_IOH_admin: false,
      is_company_admin: false,
      is_ioh_user: false,
      picture: [""],
      firstName: ["", [Validators.required, Validators.minLength(2)]],
      lastName: ["", [Validators.required, Validators.minLength(2)]],
      //gender: ['Male'],
      phone: this.formBuilder.group({
        number: ["", Validators.required],
        countryCode: [countries[0].dial_code],
      }),
      status: ["Active"],
      agency_roles: this.formBuilder.array([], [Validators.required]),
      defaultRole: ["", this.getIohUserValidator()],
      email: ["", [Validators.required, EmailValidator]],
      userSettings: this.formBuilder.group({
        ...userSettingsValues,
        // Override nonMDM to boolean for checkbox (convert string to boolean)
        nonMDM: [NonMDMCustomerEnum.NotSet]
      }),
      isIOHHelp: true,
      companyId: [""],
      provider: [""],
      loginWithPCIDenabled: [""],
      workerId: [""],
      note: [""],
      packages: this.formBuilder.array([])
    });

    (this.newUserForm.get("agency_roles") as FormArray).push(this.createAgency());
    this.iohUserChangeSubscriber();
    isMfaChange(this.newUserForm);
    this.prePopulateCompanyField();
  }

  getIohUserValidator(): any {
    let iohUser = this.newUserForm?.get("is_ioh_user")?.value;
    return iohUser ? [Validators.required] : [];
  }

  iohUserChangeSubscriber() {
    this.newUserForm.get("is_ioh_user").valueChanges.subscribe((obj) => {
      if (!obj) {
        this.newUserForm.controls["defaultRole"].reset();
      }
      let defaultRole = this.newUserForm.get("defaultRole");
      defaultRole.setValidators(this.getIohUserValidator());
      defaultRole.updateValueAndValidity();
    });
  }

  onSelectedRoleChange() {
    const formData = this.newUserForm.value;
    const index = formData.agency_roles.findIndex((agency) => agency.roles.includes(formData?.defaultRole) && agency.defaultAgency);
    if (index == -1) {
      this.newUserForm.patchValue({
        defaultRole: "",
      });
    }
    this.enableMFA(this.newUserForm.value);
    this.enableMFAToken(this.newUserForm.value);
    this.checkSelectedAgencyRoles();
    this.canEnableProvider();
  }

  canEnableProvider() {
    const formData = this.newUserForm.value;

    this.canActivateProviders = formData?.agency_roles?.some((agency_role) => agency_role?.roles?.includes(RoleID.Clinician)) || false;

    if (!this.canActivateProviders) {
      this.newUserForm.get("provider").patchValue("");
      this.newUserForm.get("provider").removeValidators(Validators.required);
      this.newUserForm.get("provider").updateValueAndValidity();

      this.newUserForm.get("loginWithPCIDenabled").patchValue("");
      this.newUserForm.get("loginWithPCIDenabled").removeValidators(Validators.required);
      this.newUserForm.get("loginWithPCIDenabled").updateValueAndValidity();

      this.newUserForm.get("workerId").removeValidators(Validators.required);
      this.newUserForm.get("workerId").updateValueAndValidity();
    }

    if (this.canActivateProviders) {
      this.newUserForm.get("provider").addValidators(Validators.required);
      this.newUserForm.get("loginWithPCIDenabled").addValidators(Validators.required);

      if(this.newUserForm.get("loginWithPCIDenabled").value === CompanyUserRegistrationTypeEnum.Enabled){
        this.newUserForm.get("workerId").addValidators(Validators.required);
      }
    }
  }

  onPCIDChange() {
    if(this.newUserForm.get("loginWithPCIDenabled").value === CompanyUserRegistrationTypeEnum.Enabled){
      this.newUserForm.get("workerId").addValidators(Validators.required);
      this.newUserForm.get("workerId").updateValueAndValidity();
    } else {
      this.newUserForm.get("workerId").removeValidators(Validators.required);
      this.newUserForm.get("workerId").updateValueAndValidity();
    }
  }

  enableMFA(formData) {
    let defaultAgencyIndex = -1;
    if (formData.agency_roles && formData.agency_roles.length)
      defaultAgencyIndex = formData.agency_roles.findIndex((agency_role) => agency_role?.defaultAgency);

    if (formData?.is_company_admin) {
      this.mfaEnabled = true;
      this.newUserForm.get("userSettings").get("mfa").setValue(false);
    } else if (
      defaultAgencyIndex !== -1 &&
      formData?.agency_roles[defaultAgencyIndex]?.roles &&
      formData?.agency_roles[defaultAgencyIndex]?.roles.length
    ) {
      this.mfaEnabled = MfaAllowedRoles.includes(formData.agency_roles[defaultAgencyIndex]?.roles[0]);
      this.newUserForm.get("userSettings").get("mfa").setValue(true);

      if (!this.mfaEnabled) this.newUserForm.get("userSettings").get("mfa").setValue(false);
    } else {
      this.newUserForm.get("userSettings").get("mfa").setValue(false);
      this.mfaEnabled = false;
    }
  }

  enableMFAToken(formData) {
    let defaultAgencyIndex = -1;
    if (formData.agency_roles && formData.agency_roles.length)
      defaultAgencyIndex = formData.agency_roles.findIndex((agency_role) => agency_role?.defaultAgency);

    if (formData?.is_company_admin) {
      this.mfaTokenEnabled = true;
      this.newUserForm.get("userSettings").get("mfa_token").setValue(false);
    } else if (
      defaultAgencyIndex !== -1 &&
      formData?.agency_roles[defaultAgencyIndex]?.roles &&
      formData?.agency_roles[defaultAgencyIndex]?.roles.length
    ) {
      this.mfaTokenEnabled = MfaAllowedRoles.includes(formData.agency_roles[defaultAgencyIndex]?.roles[0]);
      this.newUserForm.get("userSettings").get("mfa_token").setValue(false);

      if (!this.mfaTokenEnabled) this.newUserForm.get("userSettings").get("mfa_token").setValue(false);
    } else {
      this.newUserForm.get("userSettings").get("mfa_token").setValue(false);
      this.mfaTokenEnabled = false;
    }
  }

  disabledRoles(roleItem) {
    const formData = this.newUserForm.value;
    const index = formData.agency_roles.findIndex((agency) => agency.roles.includes(roleItem) && agency.defaultAgency);
    if (index > -1) {
      return false;
    }
    return true;
  }

  disabledAgency(agencyItem) {
    const formData = this.newUserForm.value;
    const index = formData.agency_roles.findIndex((agency) => agency.agency == agencyItem);
    if (index > -1) {
      return true;
    }
    return false;
  }

  createEditUsersForm() {
    let companyId;
    if (!this.users[this.selectedIndex].is_company_admin) {
      companyId = this.companies.filter((e) => e.value === this.users[this.selectedIndex]?.agencyObject[0]?.companyId)[0];
    } else {
      companyId = this.companies.filter((e) => e.value === this.users[this.selectedIndex]?.companyId)[0];
    }
    this.enableMFA(this.users[this.selectedIndex]);
    this.enableMFAToken(this.users[this.selectedIndex]);
    this.userRegistrationStatus = this.users[this.selectedIndex]?.registrationStatus === REGISTRATION_WAITING_STATUS;
    this.newUserForm.patchValue({
      is_super_admin: this.users[this.selectedIndex].is_super_admin,
      is_company_admin: this.users[this.selectedIndex].is_company_admin,
      is_ioh_user: this.users[this.selectedIndex].is_ioh_user,
      picture: this.users[this.selectedIndex].picture,
      firstName: this.users[this.selectedIndex].firstName,
      lastName: this.users[this.selectedIndex].lastName,
      phone: {
        countryCode: this.users[this.selectedIndex]?.phone?.countryCode,
        number: this.users[this.selectedIndex]?.phone?.number,
      },
      status: this.users[this.selectedIndex].status,
      defaultRole: this.users[this.selectedIndex].defaultRole,
      email: this.users[this.selectedIndex].email,
      // userSettings: {
      //   logging: this.users[this.selectedIndex]?.userSettings?.logging,
      //   loggingView: this.users[this.selectedIndex]?.userSettings?.loggingView,
      //   isMultiAgenciesAllowed: this.users[this.selectedIndex]?.userSettings?.isMultiAgenciesAllowed,
      //   mfa: this.users[this.selectedIndex]?.userSettings?.mfa,
      //   mfa_token: this.users[this.selectedIndex]?.userSettings?.mfa_token,
      //   experimentMode: this.users[this.selectedIndex]?.userSettings?.experimentMode || 0,
      //   disableUpdatePopup: this.users[this.selectedIndex]?.userSettings?.disableUpdatePopup,
      // },
      userSettings: {
        ...this.users[this.selectedIndex]?.userSettings,
        nonMDM: this.normalizeNonMdmFromApi(this.users[this.selectedIndex]?.userSettings?.nonMDM)
      },
      isIOHHelp: this.users[this.selectedIndex]?.isIOHHelp,
      companyId: companyId,
      provider: this.users[this.selectedIndex]?.provider,
      loginWithPCIDenabled: this.users[this.selectedIndex]?.loginWithPCIDenabled,
      workerId: this.users[this.selectedIndex]?.workerId,
      note: this.users[this.selectedIndex]?.note || "",
    });

    const agency_roles = this.newUserForm.get("agency_roles") as FormArray;
    this.users[this.selectedIndex]?.agency_roles?.forEach((item, index) => {
      agency_roles.push(this.createAgencyWithValues(item.agency.agencyName, item.agency.agencyID, item.roles, item.defaultAgency));
    });
    //this.checkSelectedAgencyRoles(this.selectedIndex);

    this.packages.clear();
    this.users[this.selectedIndex]?.packages?.forEach((pkg) => {
      this.packages.push(this.createPackageGroup(pkg));
    });

    this.iohUserChangeSubscriber();
    isMfaChange(this.newUserForm);
  }

  prepareEditUserForm() {
    this.checkSelectedAgencyRoles();
    this.newUserForm = this.formBuilder.group({
      is_super_admin: false,
      is_IOH_admin: false,
      is_company_admin: false,
      is_ioh_user: false,
      picture: [""],
      firstName: ["", [Validators.required, Validators.minLength(2)]],
      lastName: ["", [Validators.required, Validators.minLength(2)]],
      phone: this.formBuilder.group({
        number: ["", Validators.required],
        countryCode: [""],
      }),
      status: [""],
      agency_roles: this.formBuilder.array([]),
      defaultRole: [""],
      email: ["", [Validators.required, Validators.email]],
      userSettings: this.formBuilder.group({
        ...userSettingsValues,
        nonMDM: NonMDMCustomerEnum.NotSet
      }),
      isIOHHelp: true,
      companyId: [""],
      provider: [""],
      loginWithPCIDenabled: [""],
      workerId: [""],
      note: [""],
      packages: this.formBuilder.array([])
    });
  }

  addExperimentModeValue(option, event) {
    let totalExperimentMode = this.newUserForm.get("userSettings").get("experimentMode").value;
    if (event.checked && this.userExperimentModeValues[option]) {
      totalExperimentMode += this.userExperimentModeValues[option];
    }else if(!event.checked && totalExperimentMode >= this.userExperimentModeValues[option])
    {
      totalExperimentMode -= this.userExperimentModeValues[option];
    }
    this.newUserForm.get("userSettings").get("experimentMode").setValue(totalExperimentMode);
  }

  createAgency(): FormGroup {
    const is_company_admin = this.newUserForm.value.is_company_admin;
    const agencyValidator = is_company_admin ? [""] : ["", Validators.required];
    const rolesValidator = is_company_admin ? [[]] : [[], Validators.required];
    return this.formBuilder.group({
      agency: agencyValidator,
      roles: rolesValidator,
      defaultAgency: [false],
    });
  }

  createAgencyWithValues(agencyName, agency, roles, defaultAgency): FormGroup {
    return this.formBuilder.group({
      agency: [agency, Validators.required],
      roles: [roles, Validators.required],
      defaultAgency: [defaultAgency],
    });
  }

  onDefaultAgencyChange(index) {
    const agencyArray = this.newUserForm.get("agency_roles") as FormArray;
    const agency = agencyArray.controls[index];
    if (agency.value.defaultAgency) {
      agencyArray.controls.forEach((item, i) => {
        if (i != index) {
          item.patchValue({
            defaultAgency: false,
          });
        }
      });
    }

    this.onSelectedRoleChange();
  }

  removeChips(index) {
    const agencyArray = this.newUserForm.get("agency_roles") as FormArray;
    agencyArray.controls[index].patchValue({ roles: [] });

    this.onSelectedRoleChange();
  }

  addNewAgency() {
    (this.newUserForm.get("agency_roles") as FormArray).push(this.createAgency());
  }

  getAgencyListing(companyId?: string) {
    let params = new HttpParams();
    if ((this.currentAgencyRole.role == RoleID.Admin || this.currentAgencyRole.role == RoleID.iohAdmin) && !companyId) {
      params = undefined;
    } else if (this.currentAgencyRole.role == RoleID.companyAdmin) {
      params = params.append("companyId", `${this.currentUser.companyId}`);
    } else if (!companyId) {
      params = params.append("agency", this.currentAgencyRole.agency);
      params = params.append("role", this.currentAgencyRole.role);
    }

    if (companyId && this.currentAgencyRole.role !== RoleID.companyAdmin) {
      params = params.append("companyId", `${companyId}`);
    }

    this.subscribers.push(
      this.agencyService.getAgencies(params).subscribe((res) => {
        if (res.success) {
          this.agencyDetails = res.content.data;
          this.agencies = res.content.data.map((item) => {
            return {
              label: item.name,
              value: item.id,
            };
          });
          this.sortAgenciesByName();
          this.agenciesFilter = JSON.parse(JSON.stringify(this.agencies));

          this.originalAgenciesFilter = this.agenciesFilter.map((obj) => Object.assign({}, obj));
        }
      }),
    );
  }

  sortAgenciesByName() {
    this.agencies.sort((a, b) => {
      let fa = a.label.toLowerCase(),
        fb = b.label.toLowerCase();

      if (fa < fb) {
        return -1;
      }
      if (fa > fb) {
        return 1;
      }
      return 0;
    });
  }

  checkIfDefaultAgencySelected() {
    const agencyArray = this.newUserForm.value;

    const index = agencyArray.agency_roles.findIndex((item) => item.defaultAgency);
    if (agencyArray.agency_roles.length && index > -1) {
      return true;
    }
    if (agencyArray.is_company_admin) {
      return true;
    }
    return false;
  }

  getSelectedIcon(index) {
    const agencyArray = this.newUserForm.value;
    const rawAgency = agencyArray.agency_roles[index]?.agency;
    const selectedAgencyId =
      typeof rawAgency === "object" && rawAgency !== null && "value" in rawAgency ? (rawAgency as { value: string }).value : rawAgency;
    const selectedIndex = this.agencyDetails?.findIndex((item) => item.id == selectedAgencyId);
    return selectedIndex && selectedIndex != -1 ? this.agencyDetails[selectedIndex]?.picture : "";
  }

  onIOHAndSuperAdminChange() {
    if (!this.newUserForm.value.is_super_admin && !this.newUserForm.value.is_ioh_user) {
      this.newUserForm.get("agency_roles").setValidators([Validators.required]);
      this.newUserForm.get("agency_roles").updateValueAndValidity();
      this.newUserForm.get("defaultRole").setValidators([]);
      this.newUserForm.get("defaultRole").updateValueAndValidity();
      const data = (this.newUserForm.get("agency_roles") as FormArray).at(0);
      (this.newUserForm.get("agency_roles") as FormArray).clear();
      if (data) {
        (this.newUserForm.get("agency_roles") as FormArray).push(data);
      }
    }

    if (this.newUserForm.value.is_super_admin) {
      this.newUserForm.get("agency_roles").clearValidators();
      this.newUserForm.get("agency_roles").updateValueAndValidity();

      this.newUserForm.get("defaultRole").clearValidators();
      this.newUserForm.get("defaultRole").updateValueAndValidity();

      this.newUserForm.get("defaultRole").patchValue("");
      (this.newUserForm.get("agency_roles") as FormArray).clear();
    }
  }

  getUserListing() {
    try {
      let pagination = { pageNumber: 0, pageSize: 5 };
      this.subscribers.push(
        this.userService.getAllUsers(pagination).subscribe((res) => {
          if (res?.success) {
            this.users = res?.content?.data;
            this.totalUsers = res?.content?.totalElements;
          } else if (res) {
            this.messageHandlerService.generateToastMessage("error", "Communication error:  ", res?.errorMessage);
          }
        }),
      );
    } catch (e) {
      console.log(e);
      this.messageHandlerService.generateToastMessage("error", "Communication error: ", e?.errorMessage);
    }
  }

  getAllRoles(user): any {
    if (user.is_company_admin) {
      return ["COMPANY_ADMIN"];
    }
    if (user.agency_roles && user.agency_roles.length) {
      let res = user.agency_roles.flatMap((role) => role.roles);

      if (res.length) {
        res.sort();

        return Array.from(new Set(res));
      }
    }
  }

  canCreateUser() {
    return (
      this.currentUser?.is_super_admin ||
      this.currentAgencyRole.role == RoleID.AgencyAdmin ||
      this.currentUser?.is_IOH_admin ||
      this.currentUser?.is_company_admin
    );
  }

  searchUsers() {
    if (this.searchUser === undefined || this.searchUser === null || this.searchUser === "") {
      this.pageNo = 0;
      this.getUsers();
      this.paginator.changePage(this.pageNo);
    } else if (this.searchUser && this.searchUser.length >= this.defaultSearchMinCharacter) {
      this.pageNo = 0;
      this.getUsers();
      this.paginator.changePage(this.pageNo);
    }
  }

  getCompanyId() {
    if (this.currentUser.is_company_admin) {
      return this.currentUser.companyId;
    }
    return null;
  }

  hasUserActivityInPast(user: User) {
    const roles = this.getAllRoles(user);
    const oneHour = 60 * 60 * 1000;
    const lastActivity = new Date(user.lastActivity);
    const lastAction = new Date(user.lastAction);

    const diffHours = (lastActivity.getTime() - lastAction.getTime()) / oneHour;

    if (!Number.isNaN(diffHours) && diffHours > USER_ACTIVITY_HOURS_IN_PAST && roles?.includes(RoleID.Clinician)) {
      return true;
    } else return !!(Number.isNaN(diffHours) && roles?.includes(RoleID.Clinician));
  }

  getUsers(order: number = 0, orderBy: string = "") {
    try {
      this.progressBarService.setProgressBarVisibility(true);
      this.loading = true;
      const nonIOHUsersSorting = JSON.parse(this.localStorageService.get("nonIOHUsersSorting"));
      let request = {
        search: this.searchUser ? this.searchUser : "",
        status: this.selectedUserStatus,
        partOfAgency: this.selectedFilterAgency ? this.selectedFilterAgency : [],
        globalAgency: this.selectedAgency ? this.selectedAgency : "",
        role: this.selectedRoles,
        //pagination: { pageNumber: this.selectedUserStatus === "" ? 0 : this.pageNo, pageSize: this.noOfUsersPerRow },
        pagination: { pageNumber: this.pageNo, pageSize: this.noOfUsersPerRow },
        IOH: false,
        order: order ? order.toString() : nonIOHUsersSorting?.order.toString(),
        orderBy: orderBy ? orderBy : nonIOHUsersSorting?.orderBy,
        companyId: this.getCompanyId(),
        usersFilter: this.userFilterSelectedRows,
        provider: this.selectedProvider,
      };

      //remove GPS from usersFilter
      if (request.usersFilter && request.usersFilter.length) {
        request.usersFilter = request.usersFilter.filter((item) => item !== "GPS");
      }

      this.subscribers.push(
        this.userService.getUsersWithSearch(request).subscribe({
          next: (res) => {
            if (res?.success) {
              this.users = res?.content?.data.map((user) => {
                return { ...user, noActivity: this.hasUserActivityInPast(user) };
              });
              this.totalUsers = res?.content?.totalUsersCount;
              if (!this.isChangingPage) {
                this.changePage();
              }
            } else if (res) {
              this.messageHandlerService.generateToastMessage("error", "Communication error:  ", res?.errorMessage);
            }
            this.progressBarService.setProgressBarVisibility(false);
            this.loading = false;
          },
          error: (err) => {
            this.progressBarService.setProgressBarVisibility(false);
            this.loading = false;
            this.messageHandlerService.generateToastMessage("error", "Communication error: ", err?.error?.message || err?.message || err);
          },
        }),
      );
    } catch (e) {
      console.log(e);
      this.progressBarService.setProgressBarVisibility(false);
      this.messageHandlerService.generateToastMessage("error", "Communication error: ", e?.errorMessage);
      this.loading = false;
    }
  }

  private normalizeNonMdmFromApi(value: any): NonMDMCustomerEnum {
    if (value === NonMDMCustomerEnum.Enabled || value === "enabled" || value === true || value === "true") return NonMDMCustomerEnum.Enabled;
    if (value === NonMDMCustomerEnum.Disabled || value === "disabled" || value === false || value === "false") return NonMDMCustomerEnum.Disabled;
    if (value === NonMDMCustomerEnum.NotSet || value === "notSet") return NonMDMCustomerEnum.NotSet;
    return NonMDMCustomerEnum.NotSet;
  }

  private clearAppLinksState(): void {
    this.selectedAppLinkId = null;
    this.appLinks = [];
    this.appLinkOptions = [];
    this.isFetchingAppLinks = false;
  }

  private setupNonMdmDropdownSubscription(): void {
    // prevent stacking multiple subscriptions when editing multiple users
    if (this.nonMdmValueChangeSub) {
      this.nonMdmValueChangeSub.unsubscribe();
      this.nonMdmValueChangeSub = undefined;
    }

    const control = this.newUserForm?.get("userSettings")?.get("nonMDM");
    if (!control) return;

    const apply = (value) => {
      if (this.isSuperAdminOnlyRole && value === NonMDMCustomerEnum.Enabled) {
        this.fetchAppLinks();
      } else {
        this.clearAppLinksState();
      }
    };

    // apply initial state
    apply(control.value);

    this.nonMdmValueChangeSub = control.valueChanges.subscribe((value) => apply(value));
  }

  openEditUserForm(index: number) {
    this.selectedIndex = index;
    this.showEditForm = true;
    this.display = true;
    this.prepareEditUserForm();
    this.createEditUsersForm();
    this.isSuperAdminOnlyRole = OnlySuperAdminAllowedRoles.includes(this.currentUser?.currentUserRole);
    this.setupNonMdmDropdownSubscription();
  }

  createTooltip(users: User) {
    let res = `<b>Created On:</b> ${this.datePipe.transform(users.createdAt, dateAndTimeFormat)} ` + "<br>";
    if (users?.creator) res = res + `<b>Created By:</b> ${users?.creator}` + "<br>";

    if (users?.platform) res = res + `<b>Platform:</b> ${users?.platform} ` + "<br>";

    if (users?.desktopVersion) res = res + `<b>Desktop Version:</b> ${users?.desktopVersion} ` + "<br>";

    if (users?.androidVersion) res = res + `<b>Android Version:</b> ${users?.androidVersion}` + "<br>";

    if (this.checkIfClinician(users))
      res = res + `<b>Permissions:</b> ${users?.permissions && users?.permissions.length ? users?.permissions.join(", ") : ""}` + "<br>";

    if (users?.lastLogin) res = res + `<b>Last Login:</b> ${this.datePipe.transform(users?.lastLogin, dateAndTimeFormat)}` + "<br>";

    // if(users?.lastActivity)
    //   res = res + `<b>Last Activity:</b> ${this.datePipe.transform(users?.lastActivity, dateAndTimeFormat)}` + '<br>'
    //
    // if(users?.lastAction)
    //   res = res + `<b>Last Action:</b> ${this.datePipe.transform(users?.lastAction, dateAndTimeFormat)}` + '<br>'

    const isAdmin = this.currentAgencyRole.role === this.SUPER_ADMIN || this.currentAgencyRole.role === this.IOH_ADMIN;
    return users?.note && isAdmin ? res + `<b>Note:</b> ${users?.note}` + "<br>" : res;
  }

  checkIfClinician(user: User) {
    return !!user.agency_roles?.find((agency_role) => agency_role.roles.includes(RoleID.Clinician));
  }
  changeStatus(index: number) {
    let user: User = this.users[index];
    user.status = user.status === "Active" ? "Inactive" : "Active";
    this.updateUserStatus(user);
  }

  updateUserStatus(user: User) {
    this.progressBarService.setProgressBarVisibility(true);
    this.subscribers.push(
      this.userService.updateUser(user).subscribe((res) => {
        if (res.success) {
          this.pageNo = 0;
          this.getUsers();
          this.paginator.changePage(this.pageNo);
          this.onSlideBarClose();
          this.messageHandlerService.generateToastMessage("success", "", "User Updated Successfully");
          this.progressBarService.setProgressBarVisibility(false);
        } else {
          this.messageHandlerService.generateToastMessage("error", "", "User Not Updated");
          this.progressBarService.setProgressBarVisibility(false);
        }
      }),
    );
  }

  onAddUserClick() {
    this.showEditForm = false;
    //this.mfaEnabled = false;
    this.display = true;
    this.selectedIndex = -1;
    this.createUsersForm();
    this.getAgencyListing();

    const selectedAgencyIndex = this.filteredAgencies
      ? this.filteredAgencies?.findIndex((filteredAgency) => filteredAgency.value === this.currentAgencyRole.agency)
      : -1;
    if (!this.currentUser.is_super_admin && !this.currentUser.is_ioh_user && selectedAgencyIndex != -1) {
      // `p-dropdown` is configured with `optionValue="value"`, so the form control should store the primitive agency id.
      (this.newUserForm.get("agency_roles") as FormArray)
        .at(0)
        .get("agency")
        ?.patchValue(this.filteredAgencies[selectedAgencyIndex]?.value);
    }

    if (this.currentAgencyRole.role === this.SUPER_ADMIN || this.currentAgencyRole.role === this.IOH_ADMIN) {
      this.markCompanyIdAsRequired();
    }
  }

  bulkUpload(event) {
    uploadBulkUsers(event, {
      userService: this.userService,
      progressBarService: this.progressBarService,
      messageHandlerService: this.messageHandlerService,
      clearFile: () => this.bulkUploadUsers.clear(),
      reloadUsers: () => this.getUsers(),
    });
  }

  uploadTemplate(event) {
    this.progressBarService.setProgressBarVisibility(true);
    const file = event.files[0];

    const formData = new FormData();
    formData.append("file", file);
    this.userService.uploadTemplate(formData).subscribe((res) => {
      this.progressBarService.setProgressBarVisibility(false);
      this.bulkUploadUsers.clear();
    });
  }

  bulkUploadTemplateClick() {
    this.agencyService.getBulkUploadUsersTemplate().subscribe((res: any) => {
      if (res.success) {
        const link = document.createElement("a");
        link.href = res.content.url;
        link.download = "bulkUploadTemplate";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.messageHandlerService.generateToastMessage("success", "", FILE_DOWNLOAD_SUCCESS);
      } else {
        this.messageHandlerService.generateToastMessage("error", "", "Error Downloading File: " + res.message);
      }
    });
    this.dropdown.writeValue(this.dropdown.value === "Download Template" ? null : "Download Template");
  }

  onDropDownChange(index: number, selectedOption) {
    if (selectedOption === "Edit") {
      this.selectedIndex = index;
      this.showEditForm = true;
      this.display = true;
      this.prepareEditUserForm();
      this.createEditUsersForm();
      this.markCompanyIdAsRequired();
      this.getAgencyListing(this.preFetchCompanyId());
      this.isSuperAdminOnlyRole = OnlySuperAdminAllowedRoles.includes(this.currentUser?.currentUserRole);
      this.setupNonMdmDropdownSubscription();
    } else if (selectedOption === "Delete") {
      console.log(index);
      console.log(selectedOption);
      this.selectedIndex = index;
      this.onDeleteClick();
    }
  }

  onSidebarShow() {
    if (
      (this.currentAgencyRole.role == this.COMPANY_ADMIN || this.currentAgencyRole.role == this.AGENCY_ADMINISTRATOR) &&
      this.users[this.selectedIndex]?.id == this.currentUser?.id
    ) {
      this.messageHandlerService.generateToastMessage("error", "", "Sorry - You are not able to edit your own information or roles");
    } else if (this.users[this.selectedIndex]?.is_company_admin && this.currentUser?.is_company_admin) {
      this.messageHandlerService.generateToastMessage("error", "", "Sorry - You are not allowed to edit information or roles for following user");
    }

    this.canEnableProvider();
  }

  disableEditMode() {
    return (
      (this.currentAgencyRole.role == this.COMPANY_ADMIN && this.users[this.selectedIndex]?.is_company_admin) ||
      (this.newUserForm.value?.email == this.currentUser?.email &&
        (this.currentAgencyRole.role == this.AGENCY_ADMINISTRATOR || this.currentAgencyRole.role == this.COMPANY_ADMIN))
    );
  }

  onDeleteClick() {
    if (this.users[this.selectedIndex].aws_cognito_id == this.currentUser.aws_cognito_id) {
      this.messageHandlerService.generateToastMessage("error", "", "Cannot delete logged in user");
      return;
    }

    this.onSlideBarClose();
    this.confirmationService.confirm({
      message: "Please confirm if you wanted to delete user.",
      acceptButtonStyleClass: "btn-delete",
      accept: () => {
        this.deleteUser();
      },
    });
  }

  deleteUser(): void {
    this.progressBarService.setProgressBarVisibility(true);
    this.subscribers.push(
      this.userService.deleteUser({ aws_cognito_id: this.users[this.selectedIndex].aws_cognito_id }).subscribe((res) => {
        if (res.success) {
          this.getUsers();
          this.messageHandlerService.generateToastMessage("success", "", "User deleted Successfully");
        } else if (res) {
          this.messageHandlerService.generateToastMessage("error", "Communication error:  ", res?.errorMessage);
        }
        this.progressBarService.setProgressBarVisibility(false);
      }),
    );
  }

  setAgency(event: any, index: number) {
    (this.newUserForm.get("agency_roles") as FormArray)
      .at(index)
      .get("agency")
      ?.patchValue({ agencyID: event?.value?.id, agencyName: event?.value?.name });
  }

  // Unwraps whatever shape the "agency" control currently holds (a raw id, a
  // dropdown option {value,label}, or an already-normalized {agencyID,agencyName})
  // down to the plain agency id. Must stay idempotent: re-running createUser()/
  // updateUser() after a failed submit re-reads this same control value, and it
  // must not get treated as an opaque object and re-wrapped on the next pass.
  private extractAgencyId(agency: any): string {
    while (agency && typeof agency === "object") {
      if ("value" in agency) {
        agency = agency.value;
      } else if ("agencyID" in agency) {
        agency = agency.agencyID;
      } else {
        break;
      }
    }
    return agency;
  }

  // Same idea as extractAgencyId: companyId may already be a plain id (e.g.
  // patched as a raw string by prePopulateCompanyField for agency-admin
  // context) rather than the {label,value} dropdown option shape. Extract the
  // id either way instead of dropping the field when the shape doesn't match.
  private extractCompanyId(companyId: any): string {
    if (companyId && typeof companyId === "object" && "value" in companyId) {
      return companyId.value;
    }
    return companyId;
  }

  createUser() {
    let newUser = this.newUserForm.value;
    newUser.createdBy = this.currentUser.aws_cognito_id;
    newUser.agency_roles = newUser.agency_roles.map((item) => {
      const agencyId = this.extractAgencyId(item?.agency);
      return {
        ...item,
        agency: {
          agencyID: agencyId,
          agencyName: this.agencies.find((agency) => agency.value == agencyId)?.label,
        },
      };
    });

    // Ensure note is included in the payload
    newUser.note = this.newUserForm.value.note;

    // Backend expects string enum values: notSet | enabled | disabled.
    if (newUser.userSettings) {
      if (
        newUser.userSettings.nonMDM === undefined ||
        newUser.userSettings.nonMDM === null ||
        newUser.userSettings.nonMDM !== NonMDMCustomerEnum.NotSet &&
        newUser.userSettings.nonMDM !== NonMDMCustomerEnum.Enabled &&
        newUser.userSettings.nonMDM !== NonMDMCustomerEnum.Disabled
      ) {
        newUser.userSettings.nonMDM = NonMDMCustomerEnum.NotSet;
      }
    }

    const index = newUser?.agency_roles.findIndex((agency_role) => agency_role.defaultAgency);

    if (index != -1) newUser.defaultRole = newUser?.agency_roles[index]?.roles[0];

    if (this.currentUser.is_company_admin) {
      newUser.companyId = this.currentUser.companyId;
    }

    if (this.currentUser.is_super_admin || this.currentUser.is_IOH_admin) {
      const companyId = this.extractCompanyId(newUser.companyId);
      if (companyId) {
        newUser.companyId = companyId;
      } else {
        delete newUser.companyId;
      }
    }

    this.subscribers.push(
      this.userService.createUser(newUser).subscribe((res) => {
        if (res.success) {
          this.getUsers();

          if (this.adminRoles()) this.getAgencies();

          this.onSlideBarClose();
          this.showUserCreationSuccessPopup = true;
        } else {
          this.showUserCreationSuccessPopup = false;
          this.messageHandlerService.generateToastMessage("error", "", res.errorMessage);
        }
        this.isSubmitting = false;
      }),
    );
  }

  checkIfEmailExists() {
    this.subscribers.push(
      this.userService.findUserByEmail({ email: this.newUserForm.value.email }).subscribe((res) => {
        if (res.success && res.content.data.length && res.content.data[0]?.deleted) {
          this.messageHandlerService.generateToastMessage("error", "", USER_ACCOUNT_ALREADY_EXIST);
          this.isSubmitting = false;
        } else if (res.success && res.content.data.length) {
          this.messageHandlerService.generateToastMessage("error", "", EMAIL_ALREADY_REGISTERED_USER);
          this.isSubmitting = false;
        } else if (res.success && !res.content.data.length) {
          this.createUser();
        } else {
          this.messageHandlerService.generateToastMessage("error", "", res.errorMessage);
          this.isSubmitting = false;
        }
      }),
    );
  }

  async onSelect(event) {
    const file = event.files[0];

    const formData = new FormData();
    formData.append("file", file);

    if (event.currentFiles && event.currentFiles.length > 0) {
      this.progressBarService.setProgressBarVisibility(true);
      await this.userService.uploadFile(formData).subscribe((res) => {
        if (res?.message?.Location) {
          this.currentImage = res;
          this.newUserForm.get("picture").setValue(res.message.Location);
          this.fileUpload.clear();
        }
        this.progressBarService.setProgressBarVisibility(false);
      });
    }
  }

  async deleteFile() {
    await this.userService.deleteFile({ objectKey: this.newUserForm.value.picture }).subscribe((res) => {
      if (res) {
        this.currentImage = null;
        this.fileUpload.clear();
        this.newUserForm.patchValue({ picture: null });
      }
    });
  }

  onSlideBarClose() {
    this.isSubmitting = false;
    this.display = false;
    this.emailType = "";
    this.showEditForm = false;
    this.disableMultiAgencyFilter = true;
    (this.newUserForm.get("agency_roles") as FormArray).clear();
    this.newUserForm.reset();
    this.selectedAppLinkId = null;

    this.getAgencyListing();
    this.canEnableProvider();
  }

  updateUser() {
    try {
    if (
      this.users[this.selectedIndex].aws_cognito_id == this.currentUser.aws_cognito_id &&
      this.currentAgencyRole?.role !== this.AGENCY_ADMINISTRATOR
    ) {
      this.messageHandlerService.generateToastMessage("error", "", "Cannot update logged in user");
      return;
    }

    const user = { ...this.users[this.selectedIndex], ...this.newUserForm.value };

    // Ensure note is included in the update payload
    user.note = this.newUserForm.value.note;

    // Backend expects string enum values: notSet | enabled | disabled.
    if (user.userSettings) {
      if (
        user.userSettings.nonMDM === undefined ||
        user.userSettings.nonMDM === null ||
        user.userSettings.nonMDM !== NonMDMCustomerEnum.NotSet &&
        user.userSettings.nonMDM !== NonMDMCustomerEnum.Enabled &&
        user.userSettings.nonMDM !== NonMDMCustomerEnum.Disabled
      ) {
        user.userSettings.nonMDM = NonMDMCustomerEnum.NotSet;
      }
    }

    user.agency_roles = user.agency_roles.map((item) => {
      const agencyId = this.extractAgencyId(item?.agency);
      return {
        ...item,
        agency: {
          agencyID: agencyId,
          agencyName: this.agencies.find((agency) => agency.value == agencyId)?.label,
        },
      };
    });

    if (user.agencyObject) {
      delete user.agencyObject;
    }
    const index = user?.agency_roles.findIndex((agency_role) => agency_role.defaultAgency);

    if (index != -1) user.defaultRole = user?.agency_roles[index]?.roles[0];

    if (this.currentUser.is_company_admin) {
      user.companyId = this.currentUser.companyId;
    }
    delete user.overdueVisitCount;

    // packages is only sent while the App Packages section is on screen. Only Super Admin /
    // IOH Admin may change a package's mode, and the users list returns every clinician's app
    // list, so sending it from every role made user-agency refuse agency and company admins'
    // saves (IOHB-2069).
    if (!this.showAppPackages) {
      delete user.packages;
    }

    if (this.currentUser.is_super_admin || this.currentUser.is_IOH_admin) {
      const companyId = this.extractCompanyId(user.companyId);
      if (companyId) {
        user.companyId = companyId;
      } else {
        delete user.companyId;
      }
    }

    this.subscribers.push(
      this.userService.updateUser(user).subscribe((res) => {
        if (res?.success) {
          this.getUsers();
          this.onSlideBarClose();
          this.messageHandlerService.generateToastMessage("success", "", "User Updated Successfully");
        } else {
          this.messageHandlerService.generateToastMessage("error", "", res?.errorMessage || "Error in updating user");
        }
        this.isSubmitting = false;
      }),
    );
    }catch(error) {
      this.messageHandlerService.generateToastMessage("error", "", "An error occurred while updating the user."+error);
      this.isSubmitting = false;
   }
  }

  paginate(event) {
    if (!this.isChangingPage) {
      this.utilService.setDataInLocalStorage("globalPageLimit", "perPage", event.rows);
      this.pageNo = event.page;
      this.noOfUsersPerRow = event.rows;
      this.getUsers();
    }
  }

  changePage() {
    this.isChangingPage = true;
    setTimeout(() => {
      this.paginator.changePage(this.pageNo);
      this.isChangingPage = false;
    });
  }

  onSelectAgencyOrRole() {
    this.pageNo = 0;
    this.getUsers();
    this.paginator.changePage(this.pageNo);
    this.resetMultiSelectDataInLocalStorage();
  }

  getAgencies() {
    let params = new HttpParams();
    if (this.currentAgencyRole.role == RoleID.companyAdmin) {
      params = params.append("companyId", `${this.currentUser.companyId}`);
    }
    this.agencyService.getAgencies(params).subscribe((res) => {
      if (res.success) {
        const agencies = res.content.data;
        const allOption = { label: "All", value: "" };
        const mappedAgencies = agencies.map(({ name, id }) => ({ label: name, value: id }));
        this.filteredAgencies = [allOption, ...mappedAgencies];
      }
    });
  }

  onChangeUserStatusFilter(event) {
    this.userStatusFilter = event.value;
    this.pageNo = 0;
    this.getUsers();
    this.paginator.changePage(this.pageNo);
    this.resetMultiSelectDataInLocalStorage();
  }
  adminRoles() {
    return superAdminRoles.includes(this.currentAgencyRole?.role);
  }

  sendResetPasswordEmail() {
    const email = this.newUserForm.value.email;
    this.userService.resetPassword(email).subscribe(
      (response) => {
        if (response.success) {
          const code = response.content.data.code;
          if (code === NEW_PASSWORD_REQUEST_SEND) {
            this.messageHandlerService.generateToastMessage("success", "", TEMP_PASSWORD_EXPIRED);
          } else {
            this.utilService.sendResetPasswordEmail(email);
          }
        } else {
          this.messageHandlerService.generateToastMessage("error", "", "Error in the API call." + response.errorMessage);
        }
      },
      (error) => {
        this.messageHandlerService.generateToastMessage(error, "", "Error while fetching data. " + error.message);
      },
    );
  }

  sendOrgIdEmail() {
    const email = this.newUserForm.value.email;
    this.userService.sendOrgIdEmail(email).subscribe(
      (response) => {
        if (response.success) {
          this.messageHandlerService.generateToastMessage("success", "", response.message);
        } else {
          this.messageHandlerService.generateToastMessage("error", "", "Error in the API call." + response.message);
        }
      },
      (error) => {
        this.messageHandlerService.generateToastMessage(error, "", "Error while fetching data OR API doesn't exist" );
      },
    );
  }

  /**
   * Send activation email to the user
   */
  sendActivationEmail() {
    try {
      this.subscribers.push(
      this.userService.sendActivationEmail({ email: this.newUserForm.value.email }).subscribe((res) => {
        if (res.success) {
          this.messageHandlerService.generateToastMessage("success", "", res?.message || ACTIVATION_EMAIL_SUCCESS_MESSAGE);
        }else {
          this.messageHandlerService.generateToastMessage("error", "", "Error in the API call." + res?.message);
        }
      }),
    )

    }catch (error) {
      this.messageHandlerService.generateToastMessage("error", "", error.message);
    }
  }

  isRowVisible(rowName: string) {
    if (this.selectedRows && this.selectedRows.length) return this.selectedRows.find((selectedRow) => selectedRow === rowName);
  }

  onSelectedRowsChange() {
    let selectedNonIOH = { selectedNonIOHUserRows: [] };

    if (this.localStorageService.get("userSettings" + this.currentUser?.aws_cognito_id))
      selectedNonIOH = JSON.parse(this.localStorageService.get("userSettings" + this.currentUser?.aws_cognito_id));

    selectedNonIOH.selectedNonIOHUserRows = this.selectedRows;
    this.localStorageService.set("userSettings" + this.currentUser?.aws_cognito_id, JSON.stringify(selectedNonIOH));
  }

  isPhoneAndFaxNumberValid() {
    return this.utilService.isPhoneAndFaxNumberValid(this.newUserForm.value);
  }

  async checkSelectedAgencyRoles(selectedIndex?) {
    const formData = (await selectedIndex) ? this.users[selectedIndex] : this.newUserForm.value;
    if (!formData) {
      return;
    }

    const isMultiAgencyEnabled = isMultiAgenciesUserEnabled(formData?.agency_roles);
    if (isMultiAgencyEnabled) {
      this.disableMultiAgencyFilter = false;
      this.newUserForm.get("userSettings").get("isMultiAgenciesAllowed").patchValue(formData?.userSettings?.isMultiAgenciesAllowed);
    } else {
      this.disableMultiAgencyFilter = true;
      this.newUserForm.get("userSettings").get("isMultiAgenciesAllowed").patchValue(false);
    }
  }

  //   if(formData){
  //   formData?.agency_roles?.forEach(obj => {
  //     if(obj.roles.some(role => role == RoleID.AgencyAdmin || role == RoleID.OfficeWorker )){
  //       console.log("reached in if");
  //       this.disableMultiAgencyFilter = false;
  //     }
  //     else{
  //       this.disableMultiAgencyFilter = true;
  //       this.newUserForm.get('userSettings').get('isMultiAgenciesAllowed').patchValue(false)
  //     }
  //   })
  // }

  shouldDisableCompanyField() {
    if (this.currentUser?.is_super_admin || this.currentUser?.is_IOH_admin) {
      return false;
    }

    return true;
  }

  preFetchCompanyId() {
    if (this.currentUser?.is_company_admin || this.currentAgencyRole.role == this.AGENCY_ADMINISTRATOR) {
      return this.currentUser.companyId;
    }

    if (
      (this.currentUser?.is_IOH_admin || this.currentUser?.is_super_admin) &&
      this.newUserForm.value.companyId &&
      this.newUserForm.value.companyId &&
      "value" in this.newUserForm.value.companyId
    ) {
      return this.newUserForm.value.companyId.value;
    }
  }

  getCompanyListing(companyId?: string) {
    this.subscribers.push(
      this.companyService.getAllCompanies({ ...(companyId ? { companyId } : null) }).subscribe((res) => {
        if (res.success) {
          const activeCompanies = res.content.data.filter((company) => company.status == UserStatus.active);
          this.companies = activeCompanies.map((item) => ({ label: item.name, value: item.id }));
          this.companiesPayload = res.content.data;

          if (this.currentUser?.is_company_admin) {
            this.prePopulateCompanyField();
          }
        }
      }),
    );
  }

  prePopulateCompanyField() {
    if(this.currentAgencyRole.role == this.AGENCY_ADMINISTRATOR){
      this.newUserForm.get("companyId").patchValue( this.currentUser.companyId);
    }else {
      const filteredCompany = this.companies.filter((e) => e.value === this.currentUser.companyId)[0];
      this.newUserForm.get("companyId").patchValue(filteredCompany);
    }
  }

  onSelectCompany(event) {
    if (event.value) {
      this.confirmationService.confirm({
        message: "Please confirm if you wanted to select this Company",
        header: "Confirm Company?",
        icon: "pi pi-upload",
        acceptLabel: "Confirm",
        rejectLabel: "Cancel",
        accept: () => {
          this.getAgencyListing(this.preFetchCompanyId());
          this.changeAgencyRole();
        },
        reject: () => {
          this.newUserForm.get("companyId").patchValue("");
        },
      });
    }
  }

  filterCompanies(event) {
    let filtered: any[] = [];
    let query = event.query;
    const newUserCompanies = this.companies.filter((company) => company.label !== "All" && company.value !== "");

    for (let i = 0; i < newUserCompanies.length; i++) {
      let checkIfAlreadySelected = false;
      let company = newUserCompanies[i];
      if (company?.label?.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        const formData = this.newUserForm.value;

        if (company?.value && formData?.companyId?.value == company?.value) {
          checkIfAlreadySelected = true;
        }

        if (!checkIfAlreadySelected) {
          filtered.push(company);
        }
      }
    }

    this.filteredCompanies = filtered;
  }

  getCompanySelectedIcon(index) {
    const selectedIndex = this.companiesPayload.find((e) => e.id === index?.value);

    return selectedIndex?.logo ?? "";
  }

  removeCompany() {
    this.confirmationService.confirm({
      message: "Please confirm if you wanted to delete this Company",
      header: "Delete Company?",
      icon: "pi pi-trash",
      acceptLabel: "Delete",
      rejectLabel: "Cancel",
      acceptButtonStyleClass: "btn-delete",
      accept: () => {
        this.newUserForm.get("companyId").patchValue("");
        this.changeAgencyRole();
        this.getAgencyListing();
        this.canEnableProvider();
      },
      reject: () => {},
    });
  }

  showRemoveCompany() {
    const company = this.newUserForm?.value?.companyId?.value;

    if ((this.currentUser.is_IOH_admin || this.currentUser.is_super_admin) && company && company !== "") {
      return true;
    } else {
      return false;
    }
  }

  companyAdminChange() {
    if (this.newUserForm.get("is_company_admin").value) {
      this.markCompanyIdAsRequired();
      this.newUserForm.get("userSettings").get("mfa").setValue(true);
      this.mfaEnabled = true;
      this.mfaTokenEnabled = true;
    } else {
      this.newUserForm.get("userSettings").get("mfa").setValue(false);
      this.mfaEnabled = false;
      this.mfaTokenEnabled = false;
    }
    this.changeAgencyRole();
  }

  changeAgencyRole() {
    this.newUserForm.get("agency_roles").clearValidators();
    this.newUserForm.get("agency_roles").updateValueAndValidity();
    (this.newUserForm.get("agency_roles") as FormArray).clear();

    this.newUserForm.get("companyId").setValidators([Validators.required]);
  }

  markCompanyIdAsRequired() {
    const companyIdControl = this.newUserForm.get("companyId");

    if (companyIdControl && this.currentAgencyRole?.role !== this.AGENCY_ADMINISTRATOR) {
      companyIdControl.setValidators(Validators.required);
      companyIdControl.updateValueAndValidity();
    }
  }

  isFormControlRequired(controlName: string): boolean {
    const control = this.newUserForm.get(controlName);
    if (control) {
      const validators = control.validator({} as any);
      return validators && validators.required;
    }
    return false;
  }

  getSelectedAgencyID(user: User) {
    const selectedAgencyRole = user.agency_roles?.find((agency_role) => agency_role.roles.includes(RoleID.Clinician));
    return selectedAgencyRole?.agency?.agencyID;
  }

  onSendEmailClick(user: User) {
    this.progressBarService.setProgressBarVisibility(true);

    this.userService
      .sendPermissionsEmail({ to: user?.email, agencyID: this.getSelectedAgencyID(user) })
      .pipe(
        tap((res) => {
          const message = res && res.success ? "Email sent successfully" : "Email not sent";
          this.messageHandlerService.generateToastMessage(res && res.success ? "success" : "error", "", message);
        }),
        catchError((error) => {
          this.messageHandlerService.generateToastMessage("error", "", "Email not sent");
          return throwError(() => new Error(error));
        }),
        finalize(() => {
          this.progressBarService.setProgressBarVisibility(false);
        }),
      )
      .subscribe();
  }

  clearSelectedValues(selectedValues: any[]) {
    if (selectedValues && selectedValues.length) {
      selectedValues.splice(0, selectedValues.length);
      this.getUsers();
      this.resetMultiSelectDataInLocalStorage();
    }
  }
  sortSelectedValues() {
    this.agenciesFilter = this.utilService.sortSelectedValuesOfMultiSelect(this.originalAgenciesFilter, this.selectedFilterAgency);
  }

  validateAndSubmit() {
    this.isSubmitting = true;

    if (!this.isPhoneAndFaxNumberValid()) {
      this.messageHandlerService.generateToastMessage(
        'error',
        'Validation Error',
        'Please enter a valid phone number'
      );
      this.isSubmitting = false;
      return;
    }

    // Mark all form controls as touched to trigger validation messages
    this.markFormGroupTouched(this.newUserForm);

    // checkIfDefaultAgencySelected
    if (!this.checkIfDefaultAgencySelected() && this.newUserForm.valid) {
      this.messageHandlerService.generateToastMessage(
        'error',
        'Validation Error',
        'Please select a default agency'
      );
      this.isSubmitting = false;
      return;
    }

    if (this.newUserForm.valid) {
      this.checkIfEmailExists();
    } else {
      this.showValidationMessages();
      this.isSubmitting = false;
    }
  }

  validateAndUpdate() {
    this.isSubmitting = true;

    if (!this.isPhoneAndFaxNumberValid()) {
      this.messageHandlerService.generateToastMessage(
        'error',
        'Validation Error',
        'Please enter a valid phone number'
      );
      this.isSubmitting = false;
      return;
    }

    // Mark all form controls as touched to trigger validation messages
    this.markFormGroupTouched(this.newUserForm);

    // checkIfDefaultAgencySelected
    if (!this.checkIfDefaultAgencySelected() && this.newUserForm.valid) {
      this.messageHandlerService.generateToastMessage(
        'error',
        'Validation Error',
        'Please select a default agency'
      );
      this.isSubmitting = false;
      return;
    }

    if (this.newUserForm.valid) {
      this.updateUser();
    } else {
      this.showValidationMessages();
      this.isSubmitting = false;
    }
  }

  private markFormGroupTouched(formGroup: FormGroup) {
    Object.values(formGroup.controls).forEach(control => {
      control.markAsTouched();

      if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      }
    });
  }

  private showValidationMessages() {
    let invalidFields: string[] = [];
    const formControls = this.newUserForm.controls;

    // Check top-level form controls
    Object.keys(formControls).forEach(key => {
      const control = formControls[key];
      if (control.invalid) {
        const fieldName = this.fieldNameMap[key] || key;
        invalidFields.push(fieldName);
      }
    });

    // Check nested form groups
    const checkNestedControls = (group: FormGroup, prefix: string = '') => {
      Object.keys(group.controls).forEach(key => {
        const control = group.controls[key];
        const fullKey = prefix ? `${prefix}.${key}` : key;

        if (control instanceof FormGroup) {
          checkNestedControls(control, fullKey);
        } else if (control.invalid) {
          const fieldName = this.fieldNameMap[fullKey] || fullKey;
          invalidFields.push(fieldName);
        }
      });
    };

    // Check phone form group
    if (this.newUserForm.get('phone') instanceof FormGroup) {
      checkNestedControls(this.newUserForm.get('phone') as FormGroup, 'phone');
    }

    // Check userSettings form group
    if (this.newUserForm.get('userSettings') instanceof FormGroup) {
      checkNestedControls(this.newUserForm.get('userSettings') as FormGroup, 'userSettings');
    }

    // Check agency_roles form array
    const agencyRoles = this.newUserForm.get('agency_roles') as FormArray;
    if (agencyRoles) {
      agencyRoles.controls.forEach((roleGroup: FormGroup, index: number) => {
        if (roleGroup.invalid) {
          const missingFields: string[] = [];
          Object.keys(roleGroup.controls).forEach(key => {
            const control = roleGroup.get(key);
            if (control?.invalid) {
              const fieldName = this.fieldNameMap[key] || key;
              missingFields.push(fieldName);
            }
          });
          if (missingFields.length > 0) {
            invalidFields.push(`Agency ${index + 1}: (${missingFields.join(', ')})`);
          }
        }
      });
    }

    // remove duplicate fields
    invalidFields = [...new Set(invalidFields)];
    // remove Agency Role from invalid fields
    invalidFields = invalidFields.filter(field => field !== 'Agency Roles');

    if (invalidFields.length > 0) {
      const message = `Please fill in the following required fields: ${invalidFields.join(', ')}`;
      this.messageHandlerService.generateToastMessage('error', 'Validation Error', message);
    }
  }

  hasDefaultAgency(): boolean {
    const agencyRoles = this.newUserForm.get('agency_roles') as FormArray;
    return agencyRoles.controls.some(control => control.get('defaultAgency')?.value === true);
  }

  fetchAppLinks(): void {
    if (!OnlySuperAdminAllowedRoles.includes(this.currentUser?.currentUserRole)) {
      this.appLinks = [];
      this.appLinkOptions = [];
      return;
    }
    this.isFetchingAppLinks = true;
    this.appLinks = [];
    this.appLinkOptions = [];
    this.progressBarService.setProgressBarVisibility(true);
    this.appLinkService.getAll({ page: 1, limit: 999 }).pipe(
      finalize(() => {
        this.isFetchingAppLinks = false;
      })
    ).subscribe(
      (res: any) => {
        this.progressBarService.setProgressBarVisibility(false);
        if (res && res.success) {
          const rawData = Array.isArray(res.data)
            ? res.data
            : Array.isArray(res.content?.data)
              ? res.content.data
              : [];

          this.appLinks = rawData.map((item: any) => ({
            ...item,
            id: item._id || item.id,
          }));

          this.appLinkOptions = this.appLinks.map((app: AppLink) => ({
            label: `${app.name} - ${app.appVersion}`,
            value: app.id,
          }));

          this.selectLatestAppLink();
        } else {
          this.appLinks = [];
          this.appLinkOptions = [];
        }
      },
      (error) => {
        this.progressBarService.setProgressBarVisibility(false);
        this.appLinks = [];
        this.appLinkOptions = [];
        this.messageHandlerService.generateToastMessage("error", "", "Error fetching app links.");
      }
    );
  }

  private selectLatestAppLink(): void {
    if (this.selectedAppLinkId || !this.appLinks?.length) return;
    const latestId = this.getLatestAppLinkId(this.appLinks);
    if (latestId) {
      this.selectedAppLinkId = latestId;
    }
  }

  private getLatestAppLinkId(appLinks: AppLink[]): string | number | null {
    if (!appLinks?.length) return null;

    const parseVersion = (version?: string): number[] | null => {
      if (!version) return null;
      const parts = version.split(".").map((part) => Number(part));
      return parts.every((num) => !isNaN(num)) ? parts : null;
    };

    const sorted = [...appLinks].sort((a, b) => {
      const aParts = parseVersion(a.appVersion);
      const bParts = parseVersion(b.appVersion);

      if (aParts && bParts) {
        const maxLen = Math.max(aParts.length, bParts.length);
        for (let i = 0; i < maxLen; i++) {
          const aNum = aParts[i] || 0;
          const bNum = bParts[i] || 0;
          if (aNum !== bNum) return bNum - aNum; // higher version first
        }
      }

      const aDate = new Date(a.createdAt || 0).getTime();
      const bDate = new Date(b.createdAt || 0).getTime();
      return bDate - aDate; // newest first
    });

    return sorted[0]?.id || null;
  }

  sendEmail() {
    if (this.isSendingAppLinkEmail) return;

    if (!OnlySuperAdminAllowedRoles.includes(this.currentUser?.currentUserRole)) {
      this.messageHandlerService.generateToastMessage("error", "", "Only Super Admin can send APK email.");
      return;
    }

    if (!this.selectedAppLinkId) {
      this.messageHandlerService.generateToastMessage("error", "", "Please select an app link.");
      return;
    }

    const shouldUpdateNonMdm = this.shouldUpdateNonMdmBeforeSend();
    if (shouldUpdateNonMdm) {
      this.confirmationService.confirm({
        message: "Update Non-MDM customer setting to Enabled and send email?",
        header: "Confirm Update",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Update & Send",
        rejectLabel: "Cancel",
        accept: () => this.updateNonMdmAndSendEmail(),
        reject: () => {},
      });
      return;
    }

    this.performSendEmail();
  }

  private shouldUpdateNonMdmBeforeSend(): boolean {
    const backendNonMdm = this.normalizeNonMdmFromApi(this.users[this.selectedIndex]?.userSettings?.nonMDM);
    const localNonMdm = this.newUserForm?.get("userSettings")?.get("nonMDM")?.value;
    return localNonMdm === NonMDMCustomerEnum.Enabled && backendNonMdm !== NonMDMCustomerEnum.Enabled;
  }

  private updateNonMdmAndSendEmail(): void {
    const payload = this.buildUserNonMdmUpdatePayload();
    if (!payload) {
      this.messageHandlerService.generateToastMessage("error", "", "Unable to update Non-MDM before sending email.");
      return;
    }

    this.isSendingAppLinkEmail = true;
    this.progressBarService.setProgressBarVisibility(true);

    this.userService.updateUser(payload).subscribe(
      (res) => {
        if (res?.success) {
          this.users[this.selectedIndex] = {
            ...this.users[this.selectedIndex],
            userSettings: {
              ...(this.users[this.selectedIndex]?.userSettings || {}),
              nonMDM: NonMDMCustomerEnum.Enabled,
            } as UserSettings,
          };
          this.performSendEmail(true);
        } else {
          this.isSendingAppLinkEmail = false;
          this.progressBarService.setProgressBarVisibility(false);
          this.messageHandlerService.generateToastMessage("error", "", res?.errorMessage || "Error in updating user before sending email.");
        }
      },
      () => {
        this.isSendingAppLinkEmail = false;
        this.progressBarService.setProgressBarVisibility(false);
        this.messageHandlerService.generateToastMessage("error", "", "Error in updating user before sending email.");
      },
    );
  }

  private buildUserNonMdmUpdatePayload(): User | null {
    const existingUser = this.users[this.selectedIndex];
    if (!existingUser) return null;

    const existingSettings: Partial<UserSettings> = existingUser.userSettings
      ? { ...(existingUser.userSettings as UserSettings) }
      : {};

    const payload: User = {
      ...existingUser,
      userSettings: {
        ...existingSettings,
        nonMDM: NonMDMCustomerEnum.Enabled,
      } as UserSettings,
    };

    if ((payload as any).agencyObject) {
      delete (payload as any).agencyObject;
    }

    return payload;
  }

  private performSendEmail(alreadyLoading: boolean = false) {
    if (!alreadyLoading) {
      this.isSendingAppLinkEmail = true;
      this.progressBarService.setProgressBarVisibility(true);
    }

    let companyId;
    let agencyId;
    if (!this.users[this.selectedIndex].is_company_admin) {
      companyId = this.users[this.selectedIndex]?.agencyObject?.[0]?.companyId;
      agencyId =
        this.users[this.selectedIndex]?.agencyObject?.[0]?.id ||
        this.users[this.selectedIndex]?.agency_roles?.[0]?.agency?.agencyID;
    } else {
      companyId = this.users[this.selectedIndex]?.companyId;
    }

    if (!companyId) {
      this.isSendingAppLinkEmail = false;
      this.progressBarService.setProgressBarVisibility(false);
      this.messageHandlerService.generateToastMessage("error", "", "Company ID is required.");
      return;
    }

    const requestPayload = {
      companyId: companyId,
      userId: this.users[this.selectedIndex].id,
      apkId: this.selectedAppLinkId,
      ...(agencyId ? { agencyId } : {}),
    };

    this.userService.sendApkEmailToUser(requestPayload).subscribe(
      (res) => {
        this.isSendingAppLinkEmail = false;
        this.progressBarService.setProgressBarVisibility(false);
        if (res && res.success) {
          this.messageHandlerService.generateToastMessage("success", "", "Email sent successfully to user.");
          this.getUsers();
        }
      },
      () => {
        this.isSendingAppLinkEmail = false;
        this.progressBarService.setProgressBarVisibility(false);
        this.messageHandlerService.generateToastMessage("error", "", "Error in sending email to user.");
      },
    );
  }
}
